// The regions this console can hand an operator over to.
//
// Each region is its own notabox-server, with its own console, accounts and
// boxes (selfhost/DEPLOYING.md, "More than one control plane"). Switching
// region therefore opens that region's console, which signs you in on its own.
// The list belongs to the deployment: bootstrap.sh --regions writes it into
// env.js as "US=https://console.weavian.com,EU=https://eu.console.weavian.com".
// A console without one offers no switch.

const REGIONS_RAW =
  (typeof window !== "undefined" && window.REACT_APP_REGIONS) ||
  process.env.REACT_APP_REGIONS ||
  "";

// parseRegions reads "NAME=URL,NAME=URL" into [{ name, url }], url being the
// console's origin. An entry that does not parse is left out, and says so.
export function parseRegions(raw) {
  const regions = [];
  for (const entry of String(raw).split(",")) {
    const text = entry.trim();
    if (!text) continue;
    const eq = text.indexOf("=");
    const name = eq > 0 ? text.slice(0, eq).trim() : "";
    let url = "";
    try {
      url = new URL(text.slice(eq + 1).trim()).origin;
    } catch {
      url = "";
    }
    if (!name || !url.startsWith("http")) {
      console.error(`regions: "${text}" is not NAME=URL, so it is left out`);
      continue;
    }
    regions.push({ name, url });
  }
  return regions;
}

export const REGIONS = parseRegions(REGIONS_RAW);
